<script setup>
import logo_ie from '../../../assets/logo.jpg';
import logo_biginvest from '../../../assets/logo-biginvest.svg';
import {useI18n} from 'vue-i18n';
import {getAppDomain} from "@/helper";

const {t} = useI18n()

let logo = logo_ie;

const domain = getAppDomain();
if (domain === 'SK' || domain === 'SK/CZ') {
  logo = logo_biginvest;
} else {
  logo = logo_ie;
}
</script>

<template>
  <div id="app-loader" class="app-loader d-none">
    <div class="logo-container">
      <img :alt="t('appLoader.loading')" class="app-loader-logo" :src="logo">
      <div class="line"></div>
    </div>
  </div>
</template>

<style scoped>
.app-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.app-loader-logo {
  width: 200px;
  height: 200px;
}

.app-loader .line {
  width: 0;
  height: 4px;
  background-color: #000000;
  animation: expand-contract 1s infinite ease-in-out;
}

@keyframes expand-contract {
  0%, 100% {
    width: 25px;
  }
  99% {
    width: 200px; /* Maximální šířka */
  }
}

</style>


